export function sortEquipmentWarranty(a, b) {
    return a.start_date.localeCompare(b.start_date)
}
